exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error {\r\n    color: red;\r\n    margin-bottom: 20px;\r\n    display: inline-block;\r\n}\r\n\r\n\r\n.submitted .form-control.ng-invalid,\r\n.submitted .errorField,\r\n:host >>> .submitted .ng-invalid .ui-calendar .ui-inputtext,\r\n:host >>> .submitted .ng-invalid .ui-dropdown .ui-dropdown-label {\r\n    border-color: #DE6D31 !important;\r\n    background-color: #ffe7e7;\r\n    transition: .3s;\r\n}\r\n\r\n\r\nlabel {\r\n    text-rendering: optimizelegibility;\r\n    font-weight: 400;\r\n    font-family: \"Lato\", Sans-serif;\r\n    color: #687992;\r\n    font-weight: bold;\r\n}\r\n\r\n.input-group{\r\n    width: 300px;\r\n}\r\n\r\n.forgotPassword{\r\n    font-weight: bold;\r\n        color: #DE6D31;\r\n        text-decoration: none;\r\n        margin-left: 2.5em;\r\n        cursor: pointer;\r\n\r\n}\r\n\r\n.donthaveaccount{\r\n    margin-top: 4em;\r\n    margin-left: 6em;\r\n    font-weight: normal;\r\n}\r\n\r\n.createaccount{\r\n    margin-left: 4.5em;\r\n\r\n}\r\n.btn-success{\r\n    font-weight: bold;\r\n\r\n}\r\n.spacecomponent{\r\n    margin-top: 2em;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = 1014
// module chunks = 1